import reportError from 'ha/helpers/bugsnag/reportError';
import { load } from './actions';

export default ({ conversationId, userId }) => (dispatch, _, { apiV2 }) => {
  dispatch(load.start());

  return apiV2
    .getConversation(conversationId, {
      expand: ['messages,advertiser,tenant,stateHistory,listing'],
    })
    .then(({ data: conversation }) => {
      const isAdvertiser = conversation.advertiserId === userId;
      const getPayoutInfoP = isAdvertiser
        ? apiV2.getConversationPayoutInfo(conversationId)
        : Promise.resolve({ data: null });

      return Promise.all([
        apiV2
          .getListingPhotos(conversation.listing.id, { format: '450x' })
          .catch(error => {
            reportError(error);

            return { data: [] };
          }),
        getPayoutInfoP.catch(error => {
          reportError(error);

          return { data: null };
        }),
      ]).then(([{ data: photos }, { data: payoutInformation }]) =>
        dispatch(
          load.done({
            ...conversation,
            payoutInformation,
            listing: {
              ...conversation.listing,
              photoUrlList: photos,
            },
          }),
        ),
      );
    })
    .catch(error => dispatch(load.error(error)));
};
